import { useQuery } from '@tanstack/react-query';

import { listConnectedAccounts } from '../services/IntegrationsService';

export function useSlackConnectedAccounts(accountId?: string) {
  return useQuery({
    queryKey: ['slack-connected-accounts', accountId],
    queryFn: () => listConnectedAccounts(accountId!, 'slack'),
    enabled: !!accountId,
    staleTime: 30_000,
  });
}
